const mutations = {
  QUESTION_ORDER(state, data) {
    state.questionOrder = data;
  },
  ANSWERS(state, data) {
    state.answers = data;
  },
};

export default mutations;
